import { type IntlShape } from 'react-intl';

const DAY_MS = 1000 * 60 * 60 * 24;

// SSR-safe absolute date — used for first render before hydration swaps to relative.
export const formatAbsoluteDate = (dateString: string, intl: IntlShape): string => {
	return intl.formatDate(new Date(dateString), {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	});
};

// Relative time for < 1 day, absolute date otherwise (matches legacy).
export const formatSmartDate = (dateString: string, intl: IntlShape): string => {
	const timestamp = new Date(dateString).getTime();
	const diffMs = Date.now() - timestamp;

	if (diffMs < DAY_MS) {
		const diffSeconds = Math.floor(diffMs / 1000);
		if (diffSeconds < 60)
			return intl.formatRelativeTime(-diffSeconds, 'second', { numeric: 'auto' });
		const diffMinutes = Math.floor(diffSeconds / 60);
		if (diffMinutes < 60)
			return intl.formatRelativeTime(-diffMinutes, 'minute', { numeric: 'auto' });
		const diffHours = Math.floor(diffMinutes / 60);
		return intl.formatRelativeTime(-diffHours, 'hour', { numeric: 'auto' });
	}

	return intl.formatDate(new Date(dateString), {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	});
};
